<template>
	<div class="general-treatment">
		<v-row no-gutters align="center" class="mb-5">
			<v-btn
				color="primary"
				fab
				v-if="treatment.text == null"
				x-small
				@click="newTreatment = !newTreatment"
				:disabled="!hasPermition"
			>
				<v-icon>add</v-icon>
			</v-btn>
		</v-row>
		<v-form ref="form" v-if="newTreatment || treatment.text != null" v-model="valid">
			<v-row no-gutters class="mt-6 mb-3">
				<v-col cols="12" sm="12">
					<RichTextEditor ref="richTextEditor" :text="treatment.text" @edit="editTreatment" :category="category" :customTreatment="customTreatment" />
				</v-col>
			</v-row>
		</v-form>
		<p v-if="treatment.text == null" class="font-weight-thin ml-2" v-translate>No prescription.</p>
	</div>
</template>

<script>
import axios from "axios";
import RichTextEditor from "@/components/RichTextEditor.vue";

export default {
	name: "GeneralTreatment",
	props: {
		name: {},
		customTreatment: {},
		category: {},
		custom: {
			default: false
		},
		treatment: {
			default: () => ({
				text: null
			})
		}
	},
	components: {
		RichTextEditor
	},
	data: () => ({
		treatmentName: null,
		saving: false,
		valid: false,
		newTreatment: false
	}),
	methods: {
		validate() {
			return this.$refs.form.validate();
		},
		reset() {
			this.$refs.form.reset();
		},
		addTreatment() {
			if (this.validate()) {
				//CALL API
				this.saving = true;
				const appointmentId = this.$route.params.aid;
				const formData = new FormData();
				formData.append("appointment", appointmentId);
				formData.append("op", "add");
				formData.append("treatment", this.treatmentName);
				formData.append("category", this.category);
				axios
					.post("/app/treatment", formData)
					.then(response => {
						if (response.status === 200) {
							console.log(response.data);
							if (response.data.result === "ok") {
								//this.treatment.push(response.data.treatment);
								//this.treatment = response.data.treatments;
								this.$emit("add-treatment", response.data.treatment);
							}
							this.treatmentName = "";
							this.reset();
							this.saving = false;
						}
					})
					.catch(error => {
						console.log(error);
						this.saving = false;
					});
			}
		},
		removeTreatment(treatment) {
			//CALL API
			const appointmentId = this.$route.params.aid;
			const formData = new FormData();
			formData.append("appointment", appointmentId);
			formData.append("op", "remove");
			formData.append("treatment", treatment.text);
			formData.append("category", this.category);
			axios
				.post("/app/treatment", formData)
				.then(response => {
					if (response.status === 200) {
						console.log(response.data);
						if (response.data.result === "ok") {
							this.$emit("remove-treatment", treatment);
						}
					}
				})
				.catch(error => {
					console.log(error);
				});
		},
		editTreatment(text) {
			if (text != null && text != "<p></p>") {
				const appointmentId = this.$route.params.aid;
				const formData = new FormData();
				formData.append("appointment", appointmentId);
				formData.append("op", "edit");
				//if (this.category == "tn") {
				//	formData.append("treatment", this.treatment.text);
				//	formData.append("detail", this.treatment.text);
				//} else {
				formData.append("treatment", text);
				formData.append("detail", text);
				//}
				formData.append("category", this.category);
				formData.append("custom", this.custom);
				if(this.custom) formData.append("custom_treatment_id", this.customTreatment.id);
				axios
					.post("/app/treatment", formData)
					.then(response => {
						if (response.status === 200) {
							console.log(response.data);
							if (response.data.result === "ok") {
								console.log("edited");
								if(this.custom) this.treatment.text = response.data.treatments[0].treatment.text;
								else this.$emit("update-treatment", response.data.treatments);
							}
						}
					})
					.catch(error => {
						console.log(error);
						this.saving = false;
					});
			}
		},
		refresh() {
			if(this.$refs.richTextEditor) this.$refs.richTextEditor.update();
		}
	},
	computed: {
		hasPermition() {
			if (!this.category && this.$store.getters.hasAnyModule) return true;
			if (this.category === "nut" && this.$store.getters.hasAnyModule) {
				return true;
			} else if (
				(this.category === "qg" || this.category === "tn") &&
				this.$store.getters.hasModule("mtc")
			) {
				return true;
			} else if (this.category === "osteo" && this.$store.getters.hasModule("osteo")) {
				return true;
			} else return false;
		}
	},
	created() {
		this.$root.$on('tour-treatments-nutrition', () => {
			this.newTreatment = true;
		});
		this.$root.$on('tour-treatments-nutrition-add', () => {
			this.treatment.text = '<p>Algo...</p>';
			this.editTreatment(this.treatment.text);
		});
	},
	watch: {
		treatment() {
			console.log("watch treatment");
			//this.refresh();
		}
	}
};
</script>